(ns ballot-scout-v2-frontend.dashboard.common)

(def dis-key :days-in-service)
